module.exports = __webpack_public_path__ + "static/media/product26.f0670aa8.jpg";